<!-- eslint-disable prettier/prettier -->
<template>
  <div class="dados-pet-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <template v-slot="{observer}">
        <field-group-form>
          <v-row>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
              <v-text-field
                v-model="fields.nome"
                v-mask="{
                  mask: [Array(80).fill('X').join('')],
                  tokens: { X: { pattern: /[A-zÀ-ú\s\\.]/ } },
                  masked: true,
                }"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Nome')"
              />
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="especie"
                :rules="{ required: isOtherSpecie }"
              >
                <v-autocomplete
                  v-model="fields.especie"
                  item-text="label"
                  item-value="value"
                  outlined
                  dense
                  background-color="white"
                  :error-messages="errors"
                  class="ma-0 pa-0"
                  :items="species"
                  :label="$t('Especie')"
                  hide-no-data
                  placeholder="Digite o nome da espécie"
                  :persistent-placeholder="true"
                  :clearable="specieClearable"
                  @change="onSelectedSpecie"
                  @click="onSelectedSpecie"
                  @click:append="onClickSelectSpecie"
                  @blur="onBlurAddCustomSpecie(observer)"
                  @update:search-input="onUpdateSearchValueSpecie"
                />
              </validation-provider>
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="raca"
                :rules="{ required: isOtherBreed }"
              >
                <v-autocomplete
                  v-model="fields.raca"
                  item-text="label"
                  item-value="value"
                  outlined
                  dense
                  background-color="white"
                  name="raca"
                  :error-messages="errors"
                  class="ma-0 pa-0"
                  :items="breeds"
                  :label="$t('Raca')"
                  hide-no-data
                  placeholder="Digite o nome da raça"
                  :persistent-placeholder="true"
                  :clearable="breedClearable"
                  :loading="loadingBreeds"
                  @change="onSelectedBreed"
                  @click="onSelectedBreed"
                  @click:append="onClickSelectBreed"
                  @blur="onBlurAddCustomBreed"
                  @update:search-input="onUpdateSearchValueBreed"
                />
              </validation-provider>
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
              <v-select
                v-model="fields.sexo"
                item-text="label"
                item-value="value"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :items="genders"
                :label="$t('Sexo')"
              />
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
              <v-text-field
                v-model="fields.idade"
                v-mask="{
                  mask: ['##'],
                  tokens: { '#': { pattern: /\d/ } },
                  masked: true,
                }"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Idade')"
              />
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="chip"
                :rules="{ chipRga: chipRgaMask.rule }"
              >
                <v-text-field
                  v-model="fields.chip"
                  v-mask="{
                    mask: chipRgaMask.mask,
                    tokens: { '#': { pattern: /\d/ } },
                    masked: true,
                  }"
                  outlined
                  dense
                  background-color="white"
                  :error-messages="errors"
                  class="ma-0 pa-0"
                  :label="$t('Chip')"
                />
              </validation-provider>
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                name="rga"
                :rules="{ chipRga: chipRgaMask.rule }"
              >
                <v-text-field
                  v-model="fields.rga"
                  v-mask="{
                    mask: chipRgaMask.mask,
                    tokens: { '#': { pattern: /\d/ } },
                    masked: true,
                  }"
                  outlined
                  dense
                  background-color="white"
                  :error-messages="errors"
                  class="ma-0 pa-0"
                  :label="$t('Rga')"
                />
              </validation-provider>
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
              <v-select
                v-model="fields.statusPet"
                item-text="label"
                item-value="value"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :items="statusPets"
                :label="$t('Status_Pet')"
              />
            </v-col>
          </v-row>
        </field-group-form>
        <field-group-form :group-label="$t('Dono_Cuidador')">
          <v-row>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
              <v-text-field
                v-model="fields.nomeDono"
                v-mask="{
                  mask: [Array(80).fill('X').join('')],
                  tokens: { X: { pattern: /[A-zÀ-ú\s\\.]/ } },
                  masked: true,
                }"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Nome_Dono')"
              />
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                name="foneDono"
                :rules="{ fone: phoneMask.rule }"
              >
                <v-text-field
                  v-model="fields.foneDono"
                  v-mask="phoneMask.mask"
                  outlined
                  dense
                  background-color="white"
                  class="ma-0 pa-0"
                  :label="$t('Telefone_Dono')"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                name="cep"
                :rules="{ cep: cepMask.rule }"
              >
                <v-text-field
                  v-model="fields.cep"
                  v-mask="cepMask.mask"
                  outlined
                  dense
                  background-color="white"
                  class="ma-0 pa-0"
                  :label="$t('CEP')"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
              <v-text-field
                v-model="fields.nomeCuidador"
                v-mask="{
                  mask: [Array(80).fill('X').join('')],
                  tokens: { X: { pattern: /[A-zÀ-ú\s\\.]/ } },
                  masked: true,
                }"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Nome_Cuidador')"
              />
            </v-col>
            <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                name="foneCuidador"
                :rules="{ fone: phoneMask.rule }"
              >
                <v-text-field
                  v-model="fields.foneCuidador"
                  v-mask="phoneMask.mask"
                  outlined
                  dense
                  background-color="white"
                  class="ma-0 pa-0"
                  :label="$t('Telefone_Cuidador')"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </field-group-form>
      </template>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { extend, ValidationProvider } from "vee-validate";
import { regex, required } from "vee-validate/dist/rules";
import { updateData } from "@/services";
import i18next from "i18next";
import moment from "moment";

const _species = () => [
  {
    label: i18next.t("Gato"),
    value: i18next.t("Gato")?.toLowerCase(),
  },
  {
    label: i18next.t("Cao"),
    value: i18next.t("Cao")?.toLowerCase(),
  },
  {
    label: i18next.t("Outro"),
    value: i18next.t("Outro")?.toLowerCase(),
  },
];

const _gengers = () => [
  { label: "", value: null },
  {
    label: i18next.t("Macho"),
    value: i18next.t("Macho")?.toLowerCase(),
  },
  {
    label: i18next.t("Femea"),
    value: i18next.t("Femea")?.toLowerCase(),
  },
];

const _situations = () => [
  {
    label: i18next.t("Animal_Rua"),
    value: i18next.t("Animal_Rua")?.toLowerCase(),
  },
  {
    label: i18next.t("Animal_Abrigo"),
    value: i18next.t("Animal_Abrigo")?.toLowerCase(),
  },
  {
    label: i18next.t("Animal_Domestico"),
    value: i18next.t("Animal_Domestico")?.toLowerCase(),
  },
];

export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm, ValidationProvider },
  data() {
    return {
      isStarting: true,
      isOtherSpecie: false,
      isOtherBreed: false,
      loadingBreeds: false,
      specieInputValue: "",
      breedInputValue: "",
      specieClearable: false,
      breedClearable: false,
      fields: {
        nome: "",
        especie: "",
        raca: "",
        sexo: "",
        idade: "",
        chip: "",
        rga: "",
        statusPet: "",
        nomeDono: "",
        foneDono: "",
        cep: "",
        nomeCuidador: "",
        foneCuidador: "",
      },
      genders: _gengers(),
      species: _species(),
      breeds: [],
      statusPets: _situations(),
    };
  },
  watch: {
    "fields.especie"(next, prev) {
      if (prev && next !== prev && !this.isStarting) {
        this.fields.raca = "";
      }
    },
    "store.showModalDataForm"() {
      this.fields = { ...this.fields, ...this.data };

      let item = {
        label: this.$options.filters.toPT_BRCapitalize(this.fields.especie),
        value: this.fields.especie?.toLowerCase(),
      };

      this.species = _species();
      if (this.fields.especie) this.species.push(item);

      item = {
        label: this.$options.filters.toPT_BRCapitalize(this.fields.raca),
        value: this.fields.raca?.toLowerCase(),
      };

      if (this.fields.raca) this.breeds.push(item);

      item = {
        label: this.$options.filters.toPT_BRCapitalize(this.fields.sexo),
        value: this.fields.sexo?.toLowerCase(),
      };

      this.genders = _gengers();
      if (this.fields.sexo) this.genders.push(item);

      item = {
        label: this.$options.filters.toPT_BRCapitalize(this.fields.statusPet),
        value: this.fields.statusPet?.toLowerCase(),
      };

      this.statusPets = _situations();
      if (this.fields.statusPet) this.statusPets.push(item);

      setTimeout(() => {
        this.isStarting = !this.isStarting;
      }, 100);
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
    phoneMask() {
      return this.$store.state.language === "pt_br"
        ? {
            mask: ["(##) #####-####", "(##) ####-####"],
            rule: /\(\d\d\)\s\d{4,5}-\d{4}/,
          }
        : this.$store.state.language === "it"
        ? {
            mask: ["### ## ## ##", "### ## ## ###"],
            rule: /\d\d\d\s\d\d\s\d{2,3}/,
          }
        : { mask: ["### ### ####"], rule: /\d\d\d\s\d{3}\s\d{4}/ };
    },
    cepMask() {
      return this.$store.state.language === "en"
        ? { mask: "#########", rule: /\d{4}-\d{2}-\d{2}/ }
        : { mask: "#####-###", rule: /\d{5}-\d{3}/ };
    },
    chipRgaMask() {
      return { mask: "###############", rule: /\d{15}/ };
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);

    extend("fone", {
      ...regex,
      message: this.$t("telefone_invalido"),
    });

    extend("cep", {
      ...regex,
      message: this.$t("cep_invalido"),
    });

    extend("chipRga", {
      ...regex,
      message: this.$t("numero_15_digitos"),
    });

    extend("required", {
      ...required,
      message: this.$t("obrigatorio"),
    });
  },
  mounted() {
    const isCacheExpired = this.store.pet.breeds.cachedAt
      ? moment().diff(
          moment(this.store.pet.breeds.cachedAt).format(),
          "minutes"
        ) > 2
      : true;

    if (isCacheExpired) {
      let loadingCatBreeds = true;
      let loadingDogBreeds = true;
      this.loadingBreeds = true;
      fetch(
        "https://mylifeclick-resources.s3.sa-east-1.amazonaws.com/pet_breed/cat/pt_br.json"
      )
        .then((res) => res.json())
        .then((data) => {
          let d = data.breeds;
          d.splice(0, 0, this.$t("Outro"));
          d = d.map((e) => ({
            label: e,
            value: e.toLowerCase(),
          }));
          this.$store.commit("pet/setBreeds", {
            specie: this.$t("Gato").toLowerCase(),
            cachedAt: moment().format(),
            data: d,
          });

          this._setBreeds();
        })
        .catch(console.error)
        .finally(() => {
          loadingCatBreeds = false;
          if (!loadingDogBreeds) {
            this.loadingBreeds = false;
          }
        });

      fetch(
        "https://mylifeclick-resources.s3.sa-east-1.amazonaws.com/pet_breed/dog/pt_br.json"
      )
        .then((res) => res.json())
        .then((data) => {
          let d = data.breeds;
          d.splice(0, 0, this.$t("Outro"));
          d = d.map((e) => ({
            label: e,
            value: e.toLowerCase(),
          }));
          this.$store.commit("pet/setBreeds", {
            specie: this.$t("Cao").toLowerCase(),
            cachedAt: moment().format(),
            data: d,
          });

          this._setBreeds();
        })
        .catch(console.error)
        .finally(() => {
          loadingDogBreeds = false;
          if (!loadingCatBreeds) {
            this.loadingBreeds = false;
          }
        });
    }
  },
  methods: {
    _setBreeds() {
      this.breeds = this.store.pet.breeds
        ? this.store.pet.breeds[this.fields.especie] || []
        : [];
    },
    onSave() {
      updateData(this, "pet", this.fields);
    },
    onSelectedSpecie(value) {
      if (value === this.$t("Outro").toLowerCase()) {
        this.species = [];
        this.isOtherSpecie = true;
        this.isOtherBreed = true;
      } else {
        this.isOtherSpecie = false;
      }

      this.specieClearable = true;
    },
    onSelectedBreed(value) {
      this._setBreeds();
      if (value === this.$t("Outro").toLowerCase()) {
        this.breeds = [];
        this.isOtherBreed = true;
      } else {
        this.isOtherBreed = !this.fields.raca;
      }

      this.breedClearable = true;
    },
    onClickSelectSpecie() {
      this.species = _species();
      this.isOtherSpecie = !this.fields.especie;
      this.isOtherBreed = !this.fields.especie;
    },
    onClickSelectBreed() {
      this._setBreeds();
      this.isOtherBreed = !this.fields.raca;
    },
    onBlurAddCustomSpecie(observer) {
      if (
        i18next.language === "pt_br" &&
        /^cachor|^cadel|(^dog$)|(^vira lata$)|^viras lat|(^vira-lata$)|(^vira latas$)|(^vira-latas$)/g.test(
          this.specieInputValue?.toLowerCase()
        )
      ) {
        this.specieInputValue = "cão";
        this._setBreeds();
      } else if (
        i18next.language === "pt_br" &&
        /^gat|^felino|^felina|(^cat$)/g.test(
          this.specieInputValue?.toLowerCase()
        )
      ) {
        this.specieInputValue = "gato";
        this._setBreeds();
      }

      const item = {
        label: this.$options.filters.toPT_BRCapitalize(this.specieInputValue),
        value: this.specieInputValue?.toLowerCase(),
      };

      this.species = _species();

      const hasItem = this.species.find(
        (e) => e.label?.toLowerCase() === item.label?.toLowerCase()
      );

      if (!hasItem && item?.label) {
        this.species.push(item);
      }

      this.fields.especie =
        !item.value || item.value === this.$t("Outro").toLowerCase()
          ? ""
          : item.value;

      this.specieClearable = false;

      if (!this.fields.especie) this._setBreeds();

      this.isOtherSpecie = !this.fields.especie;
      this.isOtherBreed = true;
      observer.validate();
    },
    onUpdateSearchValueSpecie(value) {
      this.specieInputValue = value;
    },
    onBlurAddCustomBreed() {
      if (
        i18next.language === "pt_br" &&
        /^viras lat|(^vira lata$)|(^vira latas$)|(^vira-latas$)/g.test(
          this.breedInputValue?.toLowerCase()
        )
      ) {
        this.breedInputValue = "vira-lata";
      }

      const item = {
        label: this.$options.filters.toPT_BRCapitalize(this.breedInputValue),
        value: this.breedInputValue?.toLowerCase(),
      };

      this._setBreeds();

      const hasItem = this.breeds.find(
        (e) => e.label?.toLowerCase() === item.label?.toLowerCase()
      );

      if (!hasItem && item?.label) {
        this.breeds.push(item);
      }

      this.fields.raca = item.value;

      this.breedClearable = false;
    },
    onUpdateSearchValueBreed(value) {
      this.breedInputValue = value;
    },
  },
};
</script>

<style scoped></style>
